import { observable, computed, action } from 'mobx';
import { API_URL } from '../constants/constants';
import { Customer } from '../models/interfaces';
import { CompanyStore } from './CompanyStore';

import { NotificationStore } from './NotificationStore';

export class CustomerStore {
  @observable
  public customers: Array<Customer>;

  @observable
  public vermanCustomers: Array<Customer>;

  @observable
  public bioteekkiCustomers: Array<Customer>;

  public notificationStore: NotificationStore;
  public companyStore: CompanyStore;

  constructor(
    initial: Array<Customer>,
    notificationStore: NotificationStore,
    companyStore: CompanyStore
  ) {
    this.customers = initial;
    this.notificationStore = notificationStore;
    this.companyStore = companyStore;
    this.vermanCustomers = initial;
    this.bioteekkiCustomers = initial;
  }

  @computed
  get allCustomers() {
    return this.customers;
  }

  @computed
  get allVermanCustomers() {
    return this.vermanCustomers;
  }

  @computed
  get allBioteekkiCustomers() {
    return this.bioteekkiCustomers;
  }

  findCustomer(customerNo: string): Customer {
    let customer = this.customers.find(
      (_customer) => _customer.No === customerNo
    );
    if (customer) {
      return customer;
    }
    return {
      Address: '',
      City: '',
      Key: '',
      No: '',
      Name: '',
      Name2: '',
      Post_Code: '',
      company: '',
    };
  }

  filterRandomCustomer(customer: Customer) {
    return !(
      customer.No === '9999' ||
      customer.Name.toLowerCase() === 'satunnainen asiakas'
    );
  }

  async fetchCustomers() {
    const token = localStorage.getItem('token');
    const company = this.companyStore.selectedCompany;
    const url = `${API_URL}/v1/customers?company=${company}`;
    const payload = { type: 'getCustomers', company: company };

    const headers = new Headers();
    headers.append('Content-type', 'application/json');
    headers.append('X-CSRF-TOKEN', `${token}`);

    const customersData = await fetch(url, {
      headers: headers,
      method: 'GET',
      credentials: 'include',
    })
      .then((res) => {
        return res.json();
      })
      .catch((err) => {
        // @TODO Log error???
        const error = {
          type: 'error',
          message: err.message + ': Asiakkaita ei voitu hakea.',
          seen: false,
        };

        this.notificationStore.addNotification(error);
        return { error: err };
      });

    if (customersData.error) {
      // @TODO Show error message to user.
    } else if (customersData.status) {
      this.notificationStore.addNotification({
        type: 'error',
        message: 'Virhe taustajärjestelmässä: ' + customersData.errors.join(),
        seen: false,
      });
    } else {
      // If backend does not send any data, this will crash.
      this.customers = customersData.Logistico_Customers.filter((c) =>
        this.filterRandomCustomer(c)
      );
      if (company === 'Verman') {
        this.vermanCustomers = customersData.Logistico_Customers;
      } else if (company === 'Bioteekki' || company === 'Leader') {
        this.bioteekkiCustomers = customersData.Logistico_Customers;
      }
    }
  }
}

export default CustomerStore;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/CustomerStore.ts